// src/pages/VerifyEmail.jsx
import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); 
  const navigate = useNavigate();
  const alreadyCalled = useRef(false); 
  const URL= process.env.REACT_APP_SERVER_URL;
  useEffect(() => {
    const verifyEmail = async () => {
     
      if (alreadyCalled.current) return;
      alreadyCalled.current = true;

      const token = searchParams.get("token");
      const id_operator=searchParams.get("id_operator");
      if (!token&&!id_operator) {
        setStatus("error");
        return;
      }


      try {
        const response = await fetch(
          `${URL}/api/authOperator/verify?token=${token}&id_operator=${id_operator}`,
          {method:'GET',
            credentials:"include"
          }

        );
        const data = await response.json();

        if (response.ok) {
          setStatus("success");

        
          setTimeout(() => {
            navigate("/suscription");
          }, 4000);
        } else {
          setStatus("error");
        }
      } catch (error) {
        console.error("Error al verificar:", error);
        setStatus("error");
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <>
      <Navbar />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="bg-white shadow-lg rounded-2xl p-8 max-w-lg text-center">
          {status === "verifying" && (
            <p className="text-gray-700">Verificando tu correo...</p>
          )}
          {status === "success" && (
            <>
              <h2 className="text-2xl font-bold text-green-700 mb-4">
                ✅ ¡Correo verificado!
              </h2>
              <p className="text-gray-700 text-sm">
                Tu correo ha sido verificado. Serás redirigido a las suscripciones que tenemos
              </p>
            </>
          )}
          {status === "error" && (
            <>
              <h2 className="text-2xl font-bold text-red-600 mb-4">
                ❌ Verificación fallida
              </h2>
              <p className="text-gray-700 text-sm">
                El enlace no es válido o ya expiró. Solicita uno nuevo o regístrate nuevamente.
              </p>
            </>
          )}
        </div>
      </div>
    </>
  );
}
